'use strict';

import React, { PureComponent } from 'react'

import NotificationIcon from '@/Icons/NotificationIcon'

const { moment } = window;

export default class HolidaysMessage extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		if (moment().isAfter('2026-01-04', 'day')) return null;

		if (moment().isBefore('2025-12-01', 'day')) return null;

		if (props['from-header'] !== true) return null;

		let output =
		(
			<div className="holidays-msg">

				<div className="holidays-msg__content">

					<NotificationIcon />

					<p>
						Les bureaux SYNERGIES seront fermés les 26 et 31 décembre 2025 ainsi que le 2 janvier 2026. Toute l’équipe vous souhaite de belles fêtes de fin d’année.
					</p>

				</div>

			</div>
		);

		return output;
	}
}